import { overrides } from './overrides'
import { palette } from './palette'
import { props } from './props'

export const decorate = theme => ({
  palette: palette(theme),
  overrides: overrides(theme),
  props: props(theme),
})
